import ContactItem from '../Domain/ContactItem.js';
import dateTimeHelper from '../Helpers/datetimeHelper.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import ContactSearchParams from '../Contents/Sales/ContactAdmin/ContactSearchParams';

export default class contactService {
  static GetContactListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      ContactSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    const url = `/api/Contact/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetContactListByClientId(clientId, onlyWithAddress = false, clearCache = false) {
    let url = '/api/Contact/GetContactsByClientId';

    url += parseInt(clientId) > 1 ? `/${clientId}` : '/0';
    url += `?onlyWithAddress=${onlyWithAddress}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  // Resolves full names to this client's contacts - EXACT match on the four orderings a document might use
  // ("First Last", "Last First", "First, Last", "Last, First"). Unmatched names are absent from the result.
  static GetContactsByClientIdAndFullNames(clientId, fullNames) {
    const url = `/api/Contact/GetContactsByClientIdAndFullNames/${parseInt(clientId, 10)}`;

    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(fullNames ?? []));
  }

  static async GetRelatedContacts(contactId) {
    let url = '/api/Contact/GetRelatedContacts';

    url += parseInt(contactId) > 1 ? `/${contactId}` : '/0';
    url += '?clearCache=false';

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new ContactItem(item));
    }

    return [];
  }

  static EditContact(editedItem) {
    editedItem.IsActive = editedItem.IsActive.toString();
    editedItem = serviceHelper.ConvertAllPropertyToString(editedItem);
    editedItem.Birthday = dateTimeHelper.toYYYYsMMsDD(editedItem.Birthday);
    const editedItemJSON = JSON.stringify(editedItem);

    return AuthService.getInstance().CallBackendFunctionPut('/api/Contact/EditContact', editedItemJSON);
  }

  static ExportClientPOCList(searchParams) {
    const url = `/api/Contact/ExportClientPOCList/?searchParams=${JSON.stringify(searchParams)}`;
    return AuthService.getInstance().CallBackendFunctionPost(url);
  }

  static ExportOpportunityPOCList(searchParams) {
    const url = `/api/Contact/ExportOpportunityPOCList/?searchParams=${JSON.stringify(searchParams)}`;
    return AuthService.getInstance().CallBackendFunctionPost(url);
  }
}
